<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    :hiddenKeys="hiddenKeys" />
</template>

<script>
import { mapGetters } from 'vuex'
import { getCurrencyOptions } from '@Bill/utils'
import { getEnabledTableColumn } from '@/utils/common/tableColumn'
import {
  getTimeRangeTableColumn,
  getThresholdTableColumn,
  getAlarmGroupsTableColumn,
  getViewScopeTableColumn,
  getFilterList,
  getGroupList,
} from '../utils'

export default {
  name: 'BillAnalysisAlarmDetail',
  components: [
  ],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      hiddenKeys: ['status'],
      baseInfo: [
        getEnabledTableColumn(),
        getTimeRangeTableColumn(),
        getThresholdTableColumn(),
        getAlarmGroupsTableColumn(),
        getViewScopeTableColumn(),
        {
          field: 'currency',
          title: this.$t('scope.text_442'),
          formatter: ({ row }) => {
            const currencyOptions = getCurrencyOptions()
            const target = currencyOptions.filter(item => item.item_id === row.query_attributes?.origin_currency)
            if (target.length) {
              return target[0].item_name
            }
            return '-'
          },
        },
        {
          field: 'is_prepaid_amortizing',
          title: this.$t('bill.bill_prepaid_amortizing'),
          formatter: ({ row }) => {
            return row.is_prepaid_amortizing ? this.$t('table.title.on') : this.$t('table.title.off')
          },
        },
        {
          field: 'is_project_sharing',
          title: this.$t('bill.bill_project_sharing'),
          formatter: ({ row }) => {
            return row.is_project_sharing ? this.$t('table.title.on') : this.$t('table.title.off')
          },
        },
        {
          field: 'query_attributes',
          title: this.$t('monitor.text_101'),
          formatter: ({ row }) => {
            return getFilterList(row.query_attributes).map(item => item.label).join(' ')
          },
        },
        {
          field: 'group',
          title: this.$t('bill.text_297'),
          formatter: ({ row }) => {
            return getGroupList(row.group).map(item => item.label).join(' ')
          },
        },
        {
          field: 'day_record_count',
          title: this.$t('bill.day_record_count'),
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  <span style={{ color: row.day_record_count > 0 ? 'red !important' : '#606266' }}>{row.day_record_count || '0'}</span>
                </div>,
              ]
            },
          },
        },
        {
          field: 'month_record_count',
          title: this.$t('bill.month_record_count'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
}
</script>
